/**
 * Coure.Hub.PartnerContentService
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AllHubPartnerResponseDto } from '../model/allHubPartnerResponseDto';
import { CreatePartnerRequestDto } from '../model/createPartnerRequestDto';
import { HubPartnerResponseDto } from '../model/hubPartnerResponseDto';
import { UpdatePartnerRequestDto } from '../model/updatePartnerRequestDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PartnersService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param partnerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnersDeletePartnerPartnerIdDelete(partnerId: string, observe?: 'body', reportProgress?: boolean): Observable<HubPartnerResponseDto>;
    public apiPartnersDeletePartnerPartnerIdDelete(partnerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HubPartnerResponseDto>>;
    public apiPartnersDeletePartnerPartnerIdDelete(partnerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HubPartnerResponseDto>>;
    public apiPartnersDeletePartnerPartnerIdDelete(partnerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling apiPartnersDeletePartnerPartnerIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<HubPartnerResponseDto>('delete',`${this.basePath}/api/Partners/DeletePartner/${encodeURIComponent(String(partnerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnersGetAllPartnerGet(skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<AllHubPartnerResponseDto>;
    public apiPartnersGetAllPartnerGet(skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllHubPartnerResponseDto>>;
    public apiPartnersGetAllPartnerGet(skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllHubPartnerResponseDto>>;
    public apiPartnersGetAllPartnerGet(skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllHubPartnerResponseDto>('get',`${this.basePath}/api/Partners/GetAllPartner`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param partnerId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnersGetPartnerByPartnerIdPartnerIdGet(partnerId: string, observe?: 'body', reportProgress?: boolean): Observable<HubPartnerResponseDto>;
    public apiPartnersGetPartnerByPartnerIdPartnerIdGet(partnerId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HubPartnerResponseDto>>;
    public apiPartnersGetPartnerByPartnerIdPartnerIdGet(partnerId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HubPartnerResponseDto>>;
    public apiPartnersGetPartnerByPartnerIdPartnerIdGet(partnerId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (partnerId === null || partnerId === undefined) {
            throw new Error('Required parameter partnerId was null or undefined when calling apiPartnersGetPartnerByPartnerIdPartnerIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<HubPartnerResponseDto>('get',`${this.basePath}/api/Partners/GetPartnerByPartnerId/${encodeURIComponent(String(partnerId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param spId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnersGetPartnerByServiceProviderIdSpIdGet(spId: string, observe?: 'body', reportProgress?: boolean): Observable<AllHubPartnerResponseDto>;
    public apiPartnersGetPartnerByServiceProviderIdSpIdGet(spId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AllHubPartnerResponseDto>>;
    public apiPartnersGetPartnerByServiceProviderIdSpIdGet(spId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AllHubPartnerResponseDto>>;
    public apiPartnersGetPartnerByServiceProviderIdSpIdGet(spId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (spId === null || spId === undefined) {
            throw new Error('Required parameter spId was null or undefined when calling apiPartnersGetPartnerByServiceProviderIdSpIdGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AllHubPartnerResponseDto>('get',`${this.basePath}/api/Partners/GetPartnerByServiceProviderId/${encodeURIComponent(String(spId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnersInsertPartnerPost(body?: CreatePartnerRequestDto, observe?: 'body', reportProgress?: boolean): Observable<HubPartnerResponseDto>;
    public apiPartnersInsertPartnerPost(body?: CreatePartnerRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HubPartnerResponseDto>>;
    public apiPartnersInsertPartnerPost(body?: CreatePartnerRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HubPartnerResponseDto>>;
    public apiPartnersInsertPartnerPost(body?: CreatePartnerRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<HubPartnerResponseDto>('post',`${this.basePath}/api/Partners/InsertPartner`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiPartnersUpdatePartnerPut(body?: UpdatePartnerRequestDto, observe?: 'body', reportProgress?: boolean): Observable<HubPartnerResponseDto>;
    public apiPartnersUpdatePartnerPut(body?: UpdatePartnerRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<HubPartnerResponseDto>>;
    public apiPartnersUpdatePartnerPut(body?: UpdatePartnerRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<HubPartnerResponseDto>>;
    public apiPartnersUpdatePartnerPut(body?: UpdatePartnerRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<HubPartnerResponseDto>('put',`${this.basePath}/api/Partners/UpdatePartner`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
